module.exports = __webpack_public_path__ + "media/V4A.1869310f.mp4";